export default __webpack_public_path__ + "static/media/filters.9d95d2a3.svg";